import { axiosInstance } from "@/config/axios";
import { CommonRequestProps } from "@/requests";

export const deleteAttachment = async ({
  contractUuid,
  attachmentId,
}: {
  attachmentId: string;
} & CommonRequestProps) => {
  await axiosInstance.delete(`/contract/${contractUuid}/attachment/${attachmentId}`);
  return attachmentId;
};

export const deleteAttachmentRequest = async ({
  contractUuid,
  attachmentId,
}: {
  attachmentId: string;
} & CommonRequestProps) => {
  await axiosInstance.delete(`/request/${contractUuid}/attachment/${attachmentId}`);
  return attachmentId;
};
